import { Box, IconButton, InputAdornment, TextField, Theme, Typography } from "@mui/material"
import CustomTable from "../../investorOverview/common/customTable"
import HierachicalTableBody from "../../investorOverview/common/customTable/HierachicalTableBody"
import { TableHeaderData } from "../../investorOverview/types"
import { DialogCloseIcon, SearchIcon } from "../../../assets/SvgIcons"
import CustomDropdown from "../../investorOverview/directEquity/directEquityOverview/CustomDropdown"

export const hierachicalTableHeaderData: TableHeaderData[] = [
    {
        id: "categoryName",
        label: "Name",
        align: "left",
        isSortable: false
    },
    {
        id: "capitalPercent",
        label: "% of Book",
        align: "center",
        isSortable: true
    },
    {
        id: "capital",
        label: "Invested Value",
        align: "center",
        isSortable: true
    },
    {
        id: "netAssets",
        label: "Market Value",
        align: "center",
        isSortable: true
    },
    {
        id: "unrelGainLoss",
        label: "Unrealised Returns",
        align: "center",
        isSortable: true
    },
    {
        id: "unrelGainLossPercent",
        label: "IRR (%)",
        align: "center",
        isSortable: true
    },
]

export default function HierachicalTable({
    isLoading,
    tableData,
    handleSort,
    tableSortingObj,
    handleRowsPerPageChange,
    handlePageChange,
    tablePaginationObj,
    handleClearSearch,
    searchText,
    handleSearchTextChange,
    hierachyOptions,
    handleHierachyDropdown,
    selectedValue,
    handleRoleChange
}: {
    isLoading: boolean,
    tableData: any,
    handleSort: any,
    tableSortingObj: any,
    handleRowsPerPageChange: any,
    handlePageChange: any,
    tablePaginationObj: any,
    handleClearSearch: any,
    searchText: string,
    handleSearchTextChange: any,
    hierachyOptions: any,
    handleHierachyDropdown: any,
    selectedValue: string;
    handleRoleChange:any;
}): JSX.Element {

    return (
        <Box
            sx={(theme: Theme) => ({
                marginTop: "15.5px",
                borderRadius: "25px",
                padding: { xs: "10px 15px", sm: "20px 30px" },
                backgroundColor: theme.palette.common.white,
                boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`
            })}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: 'center', flexWrap: 'wrap' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '40px' }}>
                    <Typography variant='h2'
                        sx={(theme: Theme) => ({
                            fontWeight: 600,
                            fontSize: 20,
                            color: theme.palette.text.primary
                        })}>
                        Team Accounts
                    </Typography>
                    {/* <CustomDropdown IsLoading={false} options={hierachyOptions} defaultValue={hierachyFilter} setFilterValue={setHierachyFilter} /> */}
                    <CustomDropdown isLoading={false} selectedValue={selectedValue} handleValueChange={handleHierachyDropdown} dropdownOptions={hierachyOptions} />
                </Box>
                {/* Search Input */}
                <TextField
                    sx={{
                        width: { xs: '100%', sm: '25%' },
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton aria-label="Clear search"
                                    sx={{ display: searchText.length > 0 ? 'inline-flex' : 'none' }}
                                    onMouseDown={handleClearSearch}
                                >
                                    <DialogCloseIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                        sx: (theme: Theme) => ({
                            borderRadius: '25px',
                            height: '42px',
                            border: `1px solid ${theme.palette.text.secondary}B2`,
                            '& fieldset': {
                                border: 'none',
                            },
                            '& input': {
                                paddingLeft: '10px',
                                ...theme.typography.body_500,
                                color: theme.palette.text.primary,
                                '::placeholder': {
                                    ...theme.typography.subtitle_400,
                                    color: theme.palette.text.secondary,
                                    opacity: 1,
                                },
                            },
                        }),
                    }}
                    placeholder="Search"
                    value={searchText}
                    onChange={handleSearchTextChange}
                />
            </Box>
            <Box sx={{ mt: '20px' }}>
                <CustomTable
                    isLoading={isLoading}
                    tableHeaderData={hierachicalTableHeaderData}
                    tableBody={<HierachicalTableBody tableBodyData={tableData ?? []} handleRoleChange={handleRoleChange} />}
                    tableData={tableData ?? []}
                    isPaginationVisible={true}
                    tableDataCount={tablePaginationObj.totalRows}
                    handleSort={handleSort}
                    order={tableSortingObj.order}
                    orderBy={tableSortingObj.orderBy}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                    handlePageChange={handlePageChange}
                    rowsPerPage={tablePaginationObj.rowsPerPage}
                    currentPage={tablePaginationObj.currentPage}
                    rowsPerPageOptions={[5, 10, 20, 30]}
                    tableBodyLoaderRowCustomStyles={{
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },
                    }}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px"
                        }
                    }}
                    tableBodyCustomStyles={{
                        '& tr:last-child td': {
                            border: 0
                        }
                    }}
                    loadingRowsNum={5}
                    manualResponsiveBody={true}
                    hideResponsiveHeader={true}
                // ManualResponsiveBodyComponent={
                //     <MobileResponsiveBodyAmc

                //         data={tableData?.data ?? []}
                //     />
                // }
                />
            </Box>
        </Box>
    )
}